<template>
  <div class="filter-chips" role="radiogroup" :aria-label="props.ariaLabel">
    <button
      v-for="chip in props.chips"
      :key="chip.value"
      type="button"
      role="radio"
      class="filter-chips__chip"
      :class="{ 'filter-chips__chip--selected': chip.value === props.modelValue, 'filter-chips__chip--with-icon': Boolean(chip.categoryOption) }"
      :aria-checked="chip.value === props.modelValue"
      @click="emit('update:modelValue', chip.value === props.modelValue ? '' : chip.value)"
    >
      <LocationCategoryIcon v-if="chip.categoryOption" :option="chip.categoryOption" :size="24" />
      <span>{{ chip.label }}</span>
      <span v-if="chip.count != null" class="filter-chips__count">{{ chip.count }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import LocationCategoryIcon from "@components/SocialLocations/LocationCategoryIcon.vue";
import type { LocationCategoryOption } from "@logic/LocationCategories";

// Clicking the selected chip again clears it (back to the "All" chip).
export interface FilterChip {
  /** "" is the "All" chip. */
  value: string;
  label: string;
  count?: number;
  categoryOption?: LocationCategoryOption;
}

const props = defineProps<{
  modelValue: string;
  chips: FilterChip[];
  ariaLabel: string;
}>();
const emit = defineEmits<{ (e: "update:modelValue", value: string): void }>();
</script>

<style scoped lang="scss">
// Filter chips ===============================================================
.filter-chips {
  gap: 8px;
  display: flex;
  flex-wrap: wrap;

  &__chip {
    height: 34px;
    padding: 0 13px;
    gap: 7px;
    display: inline-flex;
    align-items: center;
    border: 1px solid #d8dce2;
    border-radius: 100px;
    background: #fff;
    color: #28343b;
    font: 400 13px/1 sans-serif;
    white-space: nowrap;
    cursor: pointer;

    &--with-icon {
      padding-left: 5px;
    }

    &:hover {
      border-color: #087f82;
    }

    &:focus-visible {
      outline: 2px solid #087f82;
      outline-offset: 2px;
    }

    &--selected {
      border-color: #058587;
      background: #e9f5f4;
      color: #05696b;
    }
  }

  &__count {
    color: #667085;
  }
}
</style>
